import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { getValue } from "@utils/lodash";
import "./LeftNavigation.scss";
import { useLocation } from "react-router-dom";
import {
  Nav,
  Collapse,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";
import DashboardSvgComponent from "../../../assets/svg-components/left-menu/dashboard";
import MenuAuditSvgComponent from "../../../assets/svg-components/left-menu/menuadit";
import MenuActivitySvgComponent from "../../../assets/svg-components/left-menu/menuactivity";
import MenuRepositorySvgComponent from "../../../assets/svg-components/left-menu/menurepo";
import MenuMoreSvgComponent from "../../../assets/svg-components/left-menu/menumore";
import MoreConfigSvgComponent from "../../../assets/svg-components/left-menu/more-config";
import MoreAdminSvgComponent from "../../../assets/svg-components/left-menu/more-admin";
import MoreReportSvgComponent from "../../../assets/svg-components/left-menu/more-report";
import MoreSupportSvgComponent from "../../../assets/svg-components/left-menu/more-support";
import { useNavigate } from "react-router-dom";

export default function LeftNavigation(props: any) {
  const location = useLocation();

  const {
    isOpenFirstLevel,
    isOpenSecondLevel,
    toggleFirstLevel,
    toggleSecondLevel,
    clientNavigation,
    clientMoreNavigation,
    selectedDynamicTab,
    handleDynamicTab,
    dynamicNavigation,
  } = props;

  const navigate = useNavigate();
  const handleNavigation = (item: any, link: string) => {
    if (
      getValue(item, `menu.length`, 0) === 0 ||
      getValue(item, `childrens.length`, 0) === 0
    ) {
      navigate(link);
    }
  };

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const getIcon: any = (name: string) => {
    switch (name) {
      case "dashboard":
        return <DashboardSvgComponent />;
      case "audit":
        return <MenuAuditSvgComponent />;
      case "activities":
        return <MenuActivitySvgComponent />;
      case "repository":
        return <MenuRepositorySvgComponent />;
      case "configuration":
        return <MoreConfigSvgComponent />;
      case "report":
        return <MoreReportSvgComponent />;
      case "support":
        return <MoreSupportSvgComponent />;
      case "admin":
        return <MoreAdminSvgComponent />;
      case "more":
        return <MenuMoreSvgComponent />;
      default:
        return null;
    }
  };

  const toggleTab = () => {
    var mainWrapper = document.getElementsByClassName("main-wrapper")[0];
    // var tabContentWrapper = document.getElementsByClassName("tab-content-holder")[0];
    if (mainWrapper.classList.contains("sidebar-isOpen")) {
      mainWrapper.classList.remove("sidebar-isOpen");
      props.setIsOpenFirstLevel(null);
      props.setIsOpenSecondLevel(null);
      props.setMenuActive(true);
      // tabContentWrapper.classList.remove("isActive");
    } else {
      mainWrapper.classList.add("sidebar-isOpen");
      props.setMenuActive(false);
      // tabContentWrapper.classList.add("isActive");
    }
  };
  return (
    <>
      {getValue(clientNavigation, `length`, 0) > 0 && (
        <div className="sidebar-wrapper">
          <Nav vertical className="sidebar-nav-wrapper">
            {/* ---------------- level1 tabs -------------- */}
            {getValue(clientNavigation, `length`, 0) > 0 &&
              clientNavigation.map((item: any, index: any) => {
                let activeClass = window.location.pathname
                  .split("/")
                  .includes(getValue(item, `name`, ""));
                if (getValue(item, `icon`, ""))
                  return (
                    <div className="navigation-menu" key={index}>
                      <div
                        className={`icon-sidebar-content-wrapper ${
                          activeClass ? "active" : ""
                        }`}
                        onClick={() => {
                          navigate(`${getValue(item, `childLink`, "")}`);
                          toggleFirstLevel(index);
                        }}
                      >
                        <div className="icon-wrapper">
                          {getIcon(getValue(item, "name", ""))}
                        </div>
                        <a>{getValue(item, `title`, "")}</a>
                      </div>
                      <Collapse
                        horizontal
                        isOpen={isOpenFirstLevel === index}
                        className="right-collapse submenu-wrapper"
                      >
                        <Nav vertical>
                          {getValue(item, `menu.length`, 0) > 0 &&
                            getValue(item, `menu`, []).map(
                              (submenu: any, subIndex: any) => (
                                <div
                                  key={submenu.key}
                                  className={` sidebar-submenu-items ${
                                    window.location.pathname ===
                                    getValue(submenu, `link`, "")
                                      ? "active"
                                      : ""
                                  } ${getValue(submenu, `childrens.length`, 0) >
                                  0 ? "submenu-parents" : ""} `}
                                >
                                  <a
                                    onClick={() => {
                                      handleNavigation(
                                        item,
                                        getValue(submenu, `link`, "")
                                      );
                                      toggleSecondLevel(
                                        subIndex,
                                        isOpenFirstLevel
                                      );
                                    }}
                                    className={`${
                                      window.location.pathname ===
                                      getValue(submenu, `link`, "")
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    {submenu.title}
                                    {getValue(submenu, `childrens.length`, 0) >
                                      0 && (
                                      <img
                                        className="arrow-down"
                                        src="/images/arrow-down-grey.svg"
                                      />
                                    )}
                                  </a>
                                  <Collapse
                                    isOpen={isOpenSecondLevel === subIndex}
                                    className={`sidebar-submenu-items-children ${
                                      getValue(
                                        submenu,
                                        `childrens.length`,
                                        0
                                      ) == 0
                                        ? "mt-0 mb-0"
                                        : ""
                                    }`}
                                  >
                                    <Nav vertical>
                                      {getValue(
                                        submenu,
                                        `childrens.length`,
                                        0
                                      ) > 0 &&
                                        getValue(submenu, `childrens`, []).map(
                                          (child: any, childIndex: any) => (
                                            <a
                                              key={child.key}
                                              onClick={() => {
                                                handleNavigation(
                                                  submenu,
                                                  getValue(child, `link`, "")
                                                );
                                              }}
                                              className={`${
                                                window.location.pathname ===
                                                getValue(child, `link`, "")
                                                  ? "active"
                                                  : ""
                                              }`}
                                            >
                                              {child.title}
                                            </a>
                                          )
                                        )}
                                    </Nav>
                                  </Collapse>
                                </div>
                              )
                            )}
                        </Nav>
                      </Collapse>
                    </div>
                  );
              })}
            {/* ----------------- more tabs ---------------- */}
            {getValue(clientMoreNavigation, `length`, 0) > 0 && (
              <div className="more-sidebar-link">
                <Dropdown direction="end" isOpen={dropdownOpen} toggle={toggle}>
                  <DropdownToggle>
                    <div className="icon-sidebar-content-wrapper">
                      <div className="icon-wrapper">
                        <MenuMoreSvgComponent />
                      </div>
                      <a>More</a>
                    </div>
                  </DropdownToggle>
                  <DropdownMenu>
                    <div className="nav-sidebar-list">
                      {clientMoreNavigation.map((item: object) => {
                        return (
                          <div
                            className="nav-sidebar-item d-flex align-items-center"
                            onClick={() => {
                              toggle();
                              handleDynamicTab(getValue(item, `name`, ""));
                              navigate(`${getValue(item, `childLink`, "")}`);
                            }}
                          >
                            <div className="icon-holder ">
                              {getIcon(getValue(item, "name", ""))}
                            </div>
                            <a>{getValue(item, `title`, "")}</a>
                          </div>
                        );
                      })}
                    </div>
                  </DropdownMenu>
                </Dropdown>
              </div>
            )}
          </Nav>
          
          <div>
          <div className="arrow-close-toggler" onClick={toggleTab}>
            <button className="btn">
              <img className="arrow-down" src="/images/arrow-down-grey.svg" />
            </button>
          </div>
          <div className="poweredby-footer-container">
						<p><b>Powered by AscentHR</b></p>
					</div>
          </div>
        </div>
      )}
    </>
  );
}
